import React, { useState } from 'react';
import { useAuth } from '../AuthContext';
import AddPacklistModal from './AddPacklistModal';
import EditPacklistModal from './EditPacklistModal';

const PacklistManager = () => {
  const { packlists, deletePacklist } = useAuth();
  const [isAddingPacklist, setIsAddingPacklist] = useState(false);
  const [editingPacklist, setEditingPacklist] = useState(null);
  const [expandedPacklist, setExpandedPacklist] = useState(null);

  const handleDeletePacklist = async (packlistId) => {
    if (window.confirm('Are you sure you want to delete this packlist?')) {
      await deletePacklist(packlistId);
    }
  };

  const handleEditPacklist = (packlist) => {
    setEditingPacklist(packlist);
  };

  const toggleExpanded = (packlistId) => {
    setExpandedPacklist(expandedPacklist === packlistId ? null : packlistId);
  };

  const sortedPacklists = [...packlists].sort((a, b) =>
    new Date(b.updatedAt || b.createdAt) - new Date(a.updatedAt || a.createdAt)
  );

  return (
    <div className="packlist-container">
      <div className="packlist-header">
        <h2>🎒 Activity Packlists</h2>
        <button
          className="packlist-add-button"
          onClick={() => setIsAddingPacklist(true)}
        >
          ➕ New Packlist
        </button>
      </div>

      {isAddingPacklist && (
        <AddPacklistModal
          onClose={() => setIsAddingPacklist(false)}
        />
      )}

      {editingPacklist && (
        <EditPacklistModal
          packlist={editingPacklist}
          onClose={() => setEditingPacklist(null)}
        />
      )}

      <div className="packlist-list">
        {sortedPacklists.length === 0 ? (
          <div className="packlist-empty">
            📦 No packlists yet. Create one to start organizing your activity gear!
          </div>
        ) : (
          sortedPacklists.map(packlist => (
            <div key={packlist.id} className="packlist-card">
              <div className="packlist-card-header">
                <div className="packlist-card-title">
                  <h3>{packlist.name}</h3>
                  <span className="packlist-item-count">
                    {packlist.items.length} items
                  </span>
                </div>
                <div className="packlist-card-actions">
                  <button
                    className="packlist-expand-button"
                    onClick={() => toggleExpanded(packlist.id)}
                  >
                    {expandedPacklist === packlist.id ? '▲' : '▼'}
                  </button>
                  <button
                    className="packlist-edit-button"
                    onClick={() => handleEditPacklist(packlist)}
                    title="Edit packlist"
                  >
                    ✏️
                  </button>
                  <button
                    className="packlist-delete-button"
                    onClick={() => handleDeletePacklist(packlist.id)}
                    title="Delete packlist"
                  >
                    🗑️
                  </button>
                </div>
              </div>

              <div className="packlist-card-meta">
                Created: {new Date(packlist.createdAt).toLocaleDateString()}
                {packlist.updatedAt && packlist.updatedAt !== packlist.createdAt && (
                  <span> • Updated: {new Date(packlist.updatedAt).toLocaleDateString()}</span>
                )}
              </div>

              {expandedPacklist === packlist.id && (
                <div className="packlist-items">
                  <h4>Items to pack:</h4>
                  {packlist.items.length === 0 ? (
                    <div className="packlist-items-empty">
                      No items in this packlist
                    </div>
                  ) : (
                    <ul className="packlist-items-list">
                      {packlist.items.map((item, index) => (
                        <li key={index} className="packlist-item">
                          📌 {item}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default PacklistManager;